import { GraduationCap } from "lucide-react";

export function Brand({ className = "", iconOnly = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div className="h-8 w-8 bg-primary text-primary-foreground flex items-center justify-center">
        <GraduationCap className="h-5 w-5" strokeWidth={1.8} />
      </div>
      {!iconOnly && (
        <span className="font-display text-xl font-bold tracking-tight text-foreground">
          Scholarlio
        </span>
      )}
    </div>
  );
}
